import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import Chart from 'chart.js';
import * as firebase from 'firebase'
import { listenForFirebaseItems } from './firebase-helpers'
import { map, values, pipe, juxt, filter, equals, length } from 'ramda'
import { dateStatus } from './date-helpers'

import './CompetenciesPieChart.css'

class CompetenciesPieChart extends FirebaseComponent {
  constructor() {
    super()
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        listenForFirebaseItems('competencies', competencies => {
          this.setState({ competencies })
        })
      }
      this.chart = new Chart('competencyPieChart', {
        type: 'doughnut',
        data: {
          datasets: [{
            data: [0],
            backgroundColor: ['#C9093C', '#E27B40', '#40B0B5']
          }],
          labels: ['Expired', 'Expiring', 'Valid'],
        },
        options: {
          maintainAspectRatio: false
        }
      })
    })
  }

  render() {
    if (this.state.competencies) {

      const getData = pipe(values, map(c => dateStatus(c.endDate)), juxt([
        pipe(filter(equals('expired')), length),
        pipe(filter(equals('expiring')), length),
        pipe(filter(equals('valid')), length)
      ]))

      const data = getData(this.state.competencies)

      this.chart.data.labels[0] = `Expired (${data[0]})`
      this.chart.data.labels[1] = `Expiring (${data[1]})`
      this.chart.data.labels[2] = `Valid (${data[2]})`
      this.chart.data.datasets[0].data = getData(this.state.competencies)
      this.chart.update()
    }

    return (
      <div>
        <canvas id="competencyPieChart" className="competency-pie-chart" width="300" height="300"></canvas>
      </div>
    )
  }
}

export default CompetenciesPieChart



// WEBPACK FOOTER //
// ./src/CompetenciesPieChart.js